import { Observable } from '../utils/observables/observable';
/**
 * @public
 */
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Disconnected"] = 0] = "Disconnected";
    ConnectionStatus[ConnectionStatus["Connected"] = 1] = "Connected";
})(ConnectionStatus || (ConnectionStatus = {}));
export var ConnectionType;
(function (ConnectionType) {
    ConnectionType["Bluetooth"] = "bluetooth";
    ConnectionType["Cellular"] = "cellular";
    ConnectionType["Ethernet"] = "ethernet";
    ConnectionType["Mixed"] = "mixed";
    ConnectionType["None"] = "none";
    ConnectionType["Other"] = "other";
    ConnectionType["Unknown"] = "unknown";
    ConnectionType["Wifi"] = "wifi";
})(ConnectionType || (ConnectionType = {}));
export var EffectiveType;
(function (EffectiveType) {
    EffectiveType["2G"] = "2G";
    EffectiveType["3G"] = "3G";
    EffectiveType["4G"] = "4G";
    EffectiveType["Slow2G"] = "SLOW-2G";
})(EffectiveType || (EffectiveType = {}));
/**
 * @public
 */
export class NetworkStatus {
    connectionStatusObservable = new Observable();
    getNetworkConnectionType() {
        return "unknown" /* ConnectionType.Unknown */;
    }
    onConnectionStatusChanged(handler) {
        this.connectionStatusObservable.registerObserver(handler, this);
    }
    notifyConnectionStatusChanged(status) {
        this.connectionStatusObservable.notifyObservers(status);
    }
}
//# sourceMappingURL=network-status.js.map